import { useEffect, useState } from 'react';
import { Nullable } from '../../utils/type';

export enum FieldType {
  ID = 'id',
  NAME = 'name',
  EMAIL = 'email',
  SNS = 'sns',
  LOCATION = 'location',
  PASSWORD = 'password',
  NICKNAME = 'nickname',
  PHONE = 'phone'
}

const editableFields: FieldType[] = [
  FieldType.NAME,
  FieldType.LOCATION,
  FieldType.PASSWORD,
  FieldType.NICKNAME
];

function useModalController(accountSettingModalOpen?: boolean) {
  const [fieldType, setFieldType] = useState<Nullable<FieldType>>(null);
  useEffect(() => {
    if (accountSettingModalOpen) {
      setFieldType(FieldType.LOCATION);
    }
  }, [accountSettingModalOpen]);

  const checkIsEditableField = (type: FieldType | null): boolean =>
    editableFields.includes(type as FieldType);

  const openModal = (type: FieldType) => {
    if (editableFields.includes(type)) {
      setFieldType(type);
      document.body.style.overflow = 'hidden';
    }
  };

  const closeModal = () => {
    setFieldType(null);
    document.body.style.overflow = 'visible';
  };

  return { fieldType, checkIsEditableField, openModal, closeModal };
}

export default useModalController;
